import { dataCheck } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCheck = /*#__PURE__*/createIcon(dataCheck)
export default IconCheck
